import { useUserStore } from '~/store/user'
import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useSiteStoreCode,
} from '#imports'

export default defineNuxtRouteMiddleware(async (to) => {
  const userStore = useUserStore()
  const { isEyeBotSiteStore } = useSiteStoreCode()

  // List of paths that don't require redeemed check
  const excludedPaths = [
    '/login',
    '/page-not-found',
    '/amazon/login',
    '/user/order',
    '/tracking',
    '/amazon/tracking',
    '/post-login',
    '/alreadyRedeemed',
    '/amazon/alreadyRedeemed',
    '/eyebotAlreadyRedeemed',
    '/amazon/eyebotAlreadyRedeemed',
    '/checkout/orderconfirmation',
    '/terms-of-use/employee',
    '/terms-of-use/employer/v1',
    '/terms-of-use/employer',
    '/eyebot',
    '/amazon/eyebot',
    '/return-policy',
    '/contact-us',
    '/amazon/contact-us',
    '/time-out',
    '/amazon/time-out',
    '/login-error',
    '/amazon/login-error',
  ]

  // Allow access to login routes with sessionId
  if (
    (to.path === '/login' || to.path === '/amazon/login') &&
    to.query.sessionId
  ) {
    return
  }

  // Skip check for excluded paths
  if (excludedPaths.includes(to.path)) {
    return
  }

  // If user is not logged in, redirect to appropriate login page based on path
  if (!userStore.loggedIn) {
    const isAmazonPath = to.path.startsWith('/amazon')
    return navigateTo({
      path: isAmazonPath ? '/amazon/login' : '/login',
      query: { redirect: to.fullPath },
    })
  }

  // Only check redeemed status if user is logged in
  const status = await userStore.checkIsRedeemed()
  const isAmazonPath = to.path.startsWith('/amazon')
  if (status) {
    return navigateTo(
      isEyeBotSiteStore.value
        ? isAmazonPath
          ? '/amazon/eyebotAlreadyRedeemed'
          : '/eyebotAlreadyRedeemed'
        : '/alreadyRedeemed',
    )
  }
})
